import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AppConfigService } from '@app/app-config.service';

@Component({
  selector: 'dish-navbar',
  templateUrl: './dish-navbar.component.html',
  styleUrls: ['./dish-navbar.component.scss'],
  standalone: false,
})
export class DishNavbarComponent {
  @Output() languageEventEmitter = new EventEmitter<string>();
  @Input() languages: string[];
  @Input() selectedLanguage: string;

  constructor(private config: AppConfigService) {}

  onLanguageSelect(selectedLanguage): void {
    this.languageEventEmitter.emit(selectedLanguage);
  }

  goToDish(): void {
    window.location.replace(`${this.config.get('dishBaseUrl')}`);
  }
}
